<template>
  <div class="header d-block d-md-none print-hidden">
    <div class="flex-grow-1">
      <img class="header-logo" src="@/assets/logos/av-rebrand-logo.svg" alt="AutoVerify logo" />
      <button data-test="menuOpenButton" class="menu-open-button" @click="setSidenav(true)" v-if="isAuthenticated">
        <img src="@/assets/sidebar/fa-bars.svg" alt="Sidebar menu icon" width="20" />
      </button>
    </div>
    <div class="dealership-select mt-3" v-if="isAuthenticated && currentBusinessId">
      <div class="flex-grow-1 business-dropdown-group">
        <businesses-dropdown />
      </div>
    </div>
    <div
      v-if="isAuthenticated && currentBusinessId"
      class="mobile-sidenav-container"
      :class="{ 'is-open': isMobileMenuOpen }"
    >
      <button data-test="menuCloseButton" class="menu-close-button" @click="setSidenav(false)">
        <img src="@/assets/sidebar/fa-times.svg" alt="Sidebar menu icon" width="30" />
      </button>
      <Menu />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import Menu from '@/app/global/components/Menu.vue';
import BusinessesDropdown from '@/app/global/components/BusinessesDropdown.vue';

export default {
  name: 'MobileHeader',
  components: {
    Menu,
    BusinessesDropdown,
  },
  data() {
    return {
      isMobileMenuOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      currentBusinessId: 'business/currentBusinessId',
    }),
    ...mapState({
      isAuthenticated: state => state.user.isAuthenticated,
    }),
  },
  methods: {
    setSidenav(value) {
      this.isMobileMenuOpen = value;
      if (value === false) {
        document.body.classList.remove('mobile-menu-open');
      } else {
        document.body.classList.add('mobile-menu-open');
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout', {
        auth: this.$auth,
        redirect: window.location.origin,
      });
    },
  },
  watch: {
    $route() {
      // Watch the $route change and hide sidenav
      this.setSidenav(false);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.header {
  padding: 15px;
  background-color: #fff;
  border-bottom: 2px solid $hr-color;
  .header-logo {
    height: auto;
    width: 120px;
  }
  .menu-open-button {
    position: absolute;
    right: 0;
    top: 0;
    padding: 13px 15px;
    cursor: pointer;
    background-color: #ffffff;
    border: 0;
  }
}
.mobile-sidenav-container {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transition: all 0.25s ease-in-out;
  overflow-x: hidden;
  transform: translateX(-100%);
  &.is-open {
    transform: translateX(0);
  }
  .menu-close-button {
    position: absolute;
    padding: 15px 10px;
    top: 0;
    right: 0;
    cursor: pointer;
    background-color: #ffffff;
    border: 0;
    z-index: 100000;
  }
  .button .chevron {
    display: none;
  }
}
</style>
